import "./Mm33.module.css";
import Header from "@/reusable_sections/Header";
import Vision from "./sections/Vision";
import Mission from "./sections/Mission";
import Newsletter from "./sections/Newsletter";
import History from "./sections/History";
import Commitment from "./sections/Commitment";
import StatBanner from "./sections/StatBanner";
import Footer from "@/reusable_sections/Footer";
export default function Mm33Page() {
  return <div>
      <Header />
      
      
      
      <Vision />
      <Mission />
      <Newsletter />
      <History />
      <Commitment />
      <StatBanner />
      <Footer />
    </div>;
}